import { useMutation, useQueryClient } from '@tanstack/react-query';

import { operationsApi } from '../api/operations-api';

import { operationsKeys } from './operations-keys';

/** Queues the rebuild; the index counts catch up as the worker runs, so the overview refetches. */
export function useReindexAll() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => operationsApi.reindexAll(),
    // The confirm dialog shows refusals (role, rate limit) where the operator is looking.
    meta: { silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: operationsKeys.overview() }),
  });
}
